module.exports = __webpack_public_path__ + "img/data_flow.46dcf1a6.svg";